/**
 * Created by Woody on 17/8/16.
 */
import Vue from 'vue'
import Vuex from 'vuex'

/////////////////////////////////////////////////////////
//////////测试环境、线上环境发布，请切换配置文件路径//////////
const config = require('../../config/config.prod');
/////////////////////////////////////////////////////////
//////////测试环境、线上环境发布，请切换配置文件路径//////////

Vue.use(Vuex);

const serverHost = config.serverHost;
const agentServerHost = config.agentServerHost;

const state = {
    user: "",
    token: '',
    hostInfo: {},
    activeItem: '',
    openItems: [],
    is_manager: false,
    loginRediret: config.loginRedirect,
    logoutRediret: config.logoutRedirect,
    // temporaryWhiteAPI: serverHost + '/itsec/temporaryWhite/add',
    addWhiteListAPI: serverHost + '/itsec/temporaryWhite/addWhiteList',
    getuserAPI: serverHost + '/itsec/temporaryWhite/queryLoginUser',  //
    cookieName: "currentURL=",
    selectItemList: serverHost + '/itsec/item/selectItemList',
    selectDirItems: serverHost + '/itsec/item/selectDirItems',
    updateItem: serverHost + '/itsec/item/updateItem',
    addItem: serverHost + '/itsec/item/addItem',
    deleteDocument: serverHost + "/itsec/document/deleteDocument",
    addDocument: serverHost + '/itsec/document/addDocument',
    selectDocument: serverHost + '/itsec/document/selectDocument',
    updateDocument: serverHost + '/itsec/document/updateDocument',
    tokenAPI: serverHost + "/sso/callback",
    userCertAddOne: agentServerHost + "/itsec/userCert/addOne",
    userCertGetUrl: agentServerHost + "/itsec/userCert/getS3Url",
    uploadImage: serverHost + '/itsec/document/uploadImage',
    addLangRelation: serverHost + '/itsec/item/addLangRelation',
    checkLangRelation: serverHost + '/itsec/item/checkLangRelation',
    currentLang: 'zh', // 默认语言
};

// 创建一个对象存储一系列我们接下来要写的 mutation 函数
const mutations = {
    // TODO: 放置我们的状态变更函数
    // mutation 的第一个参数是当前的 state
    // 你可以在函数里修改 state

    UPDATETOKEN(state, token) {
        state.token = token;
    },
    UPDATEUSER(state, name) {
        state.user = name;
    },
    changeActiveItem(state, activeItem) {
        state.activeItem = activeItem;
    },
    changeOpenItems(state, openItems) {
        state.openItems = openItems;
    },
    managerAuthority(state, is_manager) {
        state.is_manager = is_manager;
    },
    UPDATE_LANGUAGE(state, lang) {
        state.currentLang = lang;
    }
};

var moduleCard = {
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
};

// 整合初始状态和变更函数，我们就得到了我们所需的 store
// 至此，这个 store 就可以连接到我们的应用中
var store = new Vuex.Store({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

// action 会收到 store 作为它的第一个参数
// 既然我们只对事件的分发（dispatch 对象）感兴趣。（state 也可以作为可选项放入）
// 我们可以利用 ES6 的解构（destructuring）功能来简化对参数的导入
var actions = {
    updateUser({dispatch, state}) {
        dispatch('UPDATEUSER')
    },
    updateToken({dispatch}) {
        dispatch('UPDATETOKEN')
    },
    updateActiveItem(context, value) {
        context.commit('changeActiveItem', value)
    },
    updateOpenItems(context, value) {
        context.commit('changeOpenItems', value)
    }
};

var getters = {
    getUser(state) {
        return state.user
    },
    getToken(state) {
        return state.token
    },
    getDocumentItem(state) {
        return state.documentItem
    }
};

module.exports = store;



// WEBPACK FOOTER //
// ./src/vuex/service/store.js